import React from 'react'
import { Switch, SwitchProps } from 'react-router-dom'
import { observer } from 'mobx-react'
import { Container } from 'typescript-ioc/es5'
import { AppState } from '../../stores/app'
import { SessionState } from '@pushly/aqe'
import { ErrorPage } from '../error-page/error-page'

interface AppSwitchProps extends SwitchProps {
    handle404?: boolean
}

@observer
export class AppSwitch extends React.Component<AppSwitchProps> {
    private appState: AppState
    private sessionState: SessionState

    public constructor(props: AppSwitchProps) {
        super(props)

        this.appState = Container.get(AppState)
        this.sessionState = Container.get(SessionState)
    }

    public render() {
        const { handle404, children, ...switchProps } = this.props

        if (handle404 && this.sessionState.isAuthenticated && this.appState.showing404Count > 0) {
            if (this.appState.appIsLoading) {
                return null
            }
            return <ErrorPage errorCode={404} hideLogo={false} showAction={true} />
        }

        return <Switch {...switchProps}>{children}</Switch>
    }
}
